import { Button, Input, Tag } from "antd"
import dayjs from "dayjs"
import PropTypes from "prop-types"
import React from "react"
import { AiOutlineClockCircle } from "react-icons/ai"
import { FaMapMarker, FaRegCalendar } from "react-icons/fa"
import styled from "styled-components"

// ----------------------------------------------------------------------------

function _Slot(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, slot, location, onChange, onDeleteBooking } = props

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function renderStatus() {
        function renderDefaultBadge() {
            if (slot.booker) {
                return <Tag color="orange">Prenotato</Tag>
            }
            if (slot.visible) {
                return <Tag color="green">Abilitato</Tag>
            }
            return <Tag color="red">Disabilitato</Tag>
        }
        return (
            <div className="slot-heading-right">
                {renderDefaultBadge()}
                {slot.isReservedToAgents && <Tag color="orange">Riservato</Tag>}
            </div>
        )
    }

    function renderActions() {
        const actions = []
        if (!slot.booker) {
            if (slot.visible) {
                actions.push(
                    <Button
                        type="primary"
                        onClick={() => onChange("visible", false)}
                    >
                        Disabilita
                    </Button>
                )
            } else {
                actions.push(
                    <Button
                        type="primary"
                        onClick={() => onChange("visible", true)}
                    >
                        Abilita
                    </Button>
                )
            }
            if (slot.isReservedToAgents) {
                actions.push(
                    <Button
                        type="default"
                        onClick={() => onChange("isReservedToAgents", false)}
                    >
                        Non riservare
                    </Button>
                )
            } else {
                actions.push(
                    <Button
                        type="default"
                        onClick={() => onChange("isReservedToAgents", true)}
                    >
                        Riserva ad agenti
                    </Button>
                )
            }
        } else {
            actions.push(
                <Button type="primary" danger onClick={onDeleteBooking}>
                    Elimina prenotazione
                </Button>
            )
        }
        return <>{actions}</>
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className}`}>
            <div className="slot-heading">
                <div className="slot-heading-left">
                    <div className="slot-date">
                        <FaRegCalendar /> {dayjs(slot.date).format("D MMM")}
                    </div>
                    <div className="slot-time">
                        <AiOutlineClockCircle /> {slot.window}
                    </div>
                </div>
                {renderStatus()}
            </div>
            <div className="slot-location">
                <FaMapMarker /> {location.address}, {location.city} (
                {location.province})
            </div>
            <div className="slot-notes">
                <Input.TextArea
                    placeholder="Note"
                    value={slot.note}
                    onChange={(e) => {
                        onChange("note", e.target.value)
                    }}
                ></Input.TextArea>
            </div>
            <div className="slot-actions">{renderActions()}</div>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_Slot.propTypes = {
    className: PropTypes.string.isRequired,
    location: PropTypes.object,
    slot: PropTypes.object,
    onChange: PropTypes.func,
    onDeleteBooking: PropTypes.func,
}

_Slot.defaultProps = {}

// ----------------------------------------------------------------------------

const Slot = styled(_Slot)`
    & {
        border: 2px solid ${(props) => props?.theme?.colors?.secondaryColor};
        border-radius: 16px;
        padding: 12px 6px;
        display: flex;
        flex-direction: column;
        gap: 15px;

        svg {
            width: 18px;
            height: 18px;
        }

        .slot-heading {
            display: flex;
            justify-content: space-between;
            /* font-size: 16px; */
            font-weight: medium;
            align-items: flex-start;

            .slot-heading-left {
                display: flex;
                gap: 6px;
                justify-content: flex-start;
                flex-wrap: wrap;
            }

            .slot-heading-right {
                display: flex;
                gap: 0px;
            }

            .slot-date {
                display: flex;
                align-items: center;
                gap: 6px;
                white-space: nowrap;

                svg {
                    margin-bottom: 2px;
                }
            }

            .slot-time {
                display: flex;
                align-items: center;
                gap: 6px;
                white-space: nowrap;
            }
        }

        .slot-location {
            display: flex;
            align-items: center;
            gap: 6px;
        }
        .slot-actions {
            display: flex;
            flex-direction: row;
            gap: 6px;

            > * {
                flex: 1 0;
                display: block;
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default Slot
